export const blockIconsContentFileCopy = (
	<span className='material-symbols-outlined'>file_copy</span>
);
